import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import moment from 'moment';
import { url } from 'inspector';
import { GetContactRequest } from './constants';

@Injectable({
  providedIn: 'root'
})
export class CrmServiceService {

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private snackbar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
  ) { }

  openDialog(componentName: any, height: any, width: any, dataModel: any, maxWidth: string = '95vw', maxHeight: string = '100vh') {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    });
  }


  // Every centered confirm / small modal — one standard width (.sim-modal-pane / --sim-modal-w).
  // `height`/`width` args are kept for signature compatibility but ignored.
  openSocialBrand(componentName: any, height: any, width: any, data: any, panelClass?: string | string[]) {
    const extra = panelClass ? (Array.isArray(panelClass) ? panelClass : [panelClass]) : [];
    return this.dialog.open(componentName, {
      panelClass: ['sim-modal-pane', ...extra],
      data: data,
    });
  }

  createLead(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/leads`, data
    )
  }

  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 5000 });
  }

  // Every right-side slide-over — one standard size (.sim-drawer-pane / --sim-drawer-w).
  // `height`/`width`/`maxWidth` args are kept for signature compatibility but ignored.
  openServiceDialog(componentName: any, height: any, width: any, maxWidth: any, dataModel: any, position: any = { right: '0px', top: '0px' }) {
    return this.dialog.open(componentName, {
      panelClass: 'sim-drawer-pane',
      data: dataModel,
      disableClose: true,
      position: position,
    });
  }

  /**
   * Opens the schema-driven activity-log slide-over (Meet module) as a MatDialog. The
   * component paints its own fixed backdrop + right panel, so the dialog surface itself is
   * made invisible via the `activity-log-pane` panelClass (see styles.scss).
   * `data`: `{ prefill?: SchedulePrefill, editMeeting?: any }`.
   */
  openActivityLog(componentName: any, data: any = {}) {
    return this.dialog.open(componentName, {
      panelClass: 'activity-log-pane',
      hasBackdrop: false,
      disableClose: true,
      autoFocus: false,
      width: '100vw',
      maxWidth: '100vw',
      height: '0px',
      data: { data },
    });
  }

  /**
   * Opens the Meet activity detail view (`MeetDetailComponent`) as a right-side
   * MatDialog — the replacement for the legacy `MeetingDetailsComponent` dialog.
   * The component paints its own surface (`.mdtl--dialog`); `meet-detail-pane`
   * (styles.scss) just strips the default MatDialog padding / radius.
   * `data`: `{ meetId: string, meeting?: any }`.
   */
  openMeetDetail(componentName: any, data: any) {
    return this.dialog.open(componentName, {
      position: { right: '0px', top: '0px' },
      panelClass: ['meet-detail-pane', 'sim-drawer-pane'],
      autoFocus: false,
      disableClose: true,
      data,
    });
  }

  callingPopup(
    componentName: any,
    height: any,
    width: any,
    maxWidth: any,
    dataModel: any,
    position?: { right?: string; left?: string; top?: string; bottom?: string }
  ) {
    return this.dialog.open(componentName, {
      width,
      height,
      maxWidth,
      data: dataModel,
      disableClose: true,
      ...(position ? { position } : {}) // 🔥 key line
    });
  }

  openServiceDialogMobile(componentName: any, height: any, width: any, maxWidth: any, dataModel: any) {
    return this.dialog.open(componentName, {
      panelClass: 'sim-drawer-pane',
      data: dataModel,
      disableClose: true,
    });
  }

  getLeadApis(businessId: any, pageNo: any, size: any, leadType: any, status, staffId?: string | null) {
    let url = ""
    if (status.length > 0)
      url = url + `leadStatus=${status}`

    if (staffId && staffId.length > 0)
      url = url + `&staffId=${staffId}`

    return this.http.get(
      environment.baseUrl + `crm/lead/v2?businessId=${businessId}&size=${size}&pageNo=${pageNo}&leadType=${leadType}&${url}`
    )
  }

  getLeadApiswithoutLeadType(businessId: any, pageNo: any, size: any, staffId: any = '') {
    return this.http.get(
      environment.baseUrl + `crm/lead/v2?businessId=${businessId}&size=${size}&pageNo=${pageNo}&staffId=${staffId}`
    )
  }

  searchLeadApis(businessId: any, text: any, pageNo: any, size: any) {
    return this.http.get(
      environment.baseUrl + `crm/leads?businessId=${businessId}&size=${size}&pageNo=${pageNo}&text=${text}`
    )
  }

  searchStudentList(businessId: any, searchText: any) {
    return this.http.put(
      environment.baseUrl + `crm/leads/search?searchText=${searchText}&businessId=${businessId}`, ''
    )
  }
  searchLeadsCustomers(businessId: any, pageNo: any, size: any, leadType: any, searchText: any, staffId?: string | null) {

    let url = ""

    if (staffId && staffId.length > 0) {
      url = url + `&staffId=${staffId}`
    }

    return this.http.get(
      environment.baseUrl + `crm/lead/v2?businessId=${businessId}&pageNo=${pageNo}&size=${size}&leadType=${leadType}&text=${searchText}${url}`
    )
  }
  deleteContact(id: any) {
    return this.http.delete(
      environment.baseUrl + `crm/leads?leadId=${id}`
    )
  }

  getLeadTimeline(leadId: any, type: any) {
    return this.http.get(
      environment.baseUrl + `crm/leads/timeline?leadId=${leadId}&type=${type}`
    )
  }

  addTimeLine(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/leads/timeline/add`, data
    )
  }

  getLeadById(leadId: any) {
    return this.http.get(
      environment.baseUrl + `crm/leads/get-one?leadId=${leadId}`
    )
  }

  updateLead(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/leads`, data
    )
  }

  changeLeadStatus(leadStatus: any, leadId: any, isDeleted: any) {
    return this.http.post(
      environment.baseUrl + `crm/leads/action?leadStatus=${leadStatus}&leadId=${leadId}&isDeleted=${isDeleted}`, {}
    )
  }

  openBottomSheet(componentName: any, data: any) {
    return this._bottomSheet.open(componentName, {
      data: data,

    });
  }

  // notes module
  listNotes(leadId: any, recentFirst: any) {
    return this.http.get(
      environment.baseUrl + `crm/notes?leadId=${leadId}&recentFirst=${recentFirst}`
    )
  }
  createNotes(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/notes/create`, data
    )
  }
  createNoteForTimeline(timelineId: any, data: any) {
    return this.http.post(
      environment.baseUrl + `crm/notes/timeline/${timelineId}/create`, data
    )
  }
  updateNotes(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/notes/update`, data
    )
  }
  deleteNotes(noteId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/notes/delete/${noteId}`
    )
  }

  // attachments module
  listAttachments(leadId: any) {
    return this.http.get(
      environment.baseUrl + `crm/attachment?leadId=${leadId}`
    )
  }
  createAttachment(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/attachment/create`, data
    )
  }
  createAttachmentForTimeline(timelineId: any, data: any) {
    return this.http.post(
      environment.baseUrl + `crm/attachment/timeline/${timelineId}/create`, data
    )
  }
  deleteAttachment(attachmentId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/attachment/delete/${attachmentId}`
    )
  }

  updateAttachment(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/attachment/update`, data
    )
  }

  viewAttachments(attachmentId: any) {
    return this.http.get(
      environment.baseUrl + `crm/attachment/get/${attachmentId}`
    )
  }

  searchAttachments(leadId: any, text: any) {
    return this.http.get(
      environment.baseUrl + `crm/attachment/search/${leadId}?text=${text}`
    )
  }

  // calls module
  listCalls(businessId: any, pageNo: any, size: any, callStatus: any) {
    return this.http.get(
      environment.baseUrl + `crm/call?businessId=${businessId}&pageNo=${pageNo}&size=${size}&callStatus=${callStatus}`
    )
  }

  CallsListByLeadId(leadId: any, pageNo: any, size: any, callStatus: any) {
    return this.http.get(
      environment.baseUrl + `crm/call/bylead?leadId=${leadId}&pageNo=${pageNo}&size=${size}&callStatus=${callStatus}`
    )
  }
  searchCalls(businessId: any, pageNo: any, size: any, callStatus: any, searchText: any) {
    return this.http.get(
      environment.baseUrl + `crm/call?businessId=${businessId}&pageNo=${pageNo}&size=${size}&callStatus=${callStatus}&text=${searchText}`
    )
  }
  createCall(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/call/create`, data
    )
  }
  editCall(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/call/update`, data
    )
  }
  callFilter(businessId: any, pageNo: any, size: any, startDate: any, endDate: any, data: any) {
    if (startDate && endDate) {
      return this.http.put(
        environment.baseUrl + `crm/call/filter/${businessId}?pageNo=${pageNo}&size=${size}&startDate=${startDate}&endDate=${endDate}`, data
      )
    } else {
      return this.http.put(
        environment.baseUrl + `crm/call/filter/${businessId}?pageNo=${pageNo}&size=${size}`, data
      )
    }

  }
  callListFilter(
    businessId: any,
    pipelineId?: any,
    pageNo?: any,
    size?: any,
    startDate?: any,
    endDate?: any,
    data?: any,
  ) {
    // Build query params dynamically
    let queryParams = `?pageNo=${pageNo}&size=${size}`;

    if (pipelineId) {
      queryParams += `&pipelineId=${pipelineId}`;
    }

    if (startDate && endDate) {
      queryParams += `&startDate=${startDate}&endDate=${endDate}`;
    }

    if (data?.staffId) {
      queryParams += `&staffId=${data.staffId}`;
    }

    // Build final URL
    const url = `${environment.baseUrl}crm/call/filter/${businessId}${queryParams}`;

    // Call API
    return this.http.put(url, data);
  }

  changeCallStatus(callId: any, status: any) {
    return this.http.put(
      environment.baseUrl + `crm/call/change/status?callId=${callId}&callStatus=${status}`, {}
    )
  }
  getCallDetails(callId: any) {
    return this.http.get(
      environment.baseUrl + `crm/call/${callId}`
    )
  }
  getNotesByCallId(callId: any) {
    return this.http.get(
      environment.baseUrl + `crm/call/taskDoc/${callId}`
    )
  }
  createNotesByCallId(callId: any, data: any) {
    return this.http.post(
      environment.baseUrl + `crm/call/notes/create/${callId}`, data
    )
  }
  editNotesByCallId(callId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `crm/call/notes/update/${callId}`, data
    )
  }
  deleteNotesByCallId(callId: any, noteId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/call/notes/delete/${callId}?notesId=${noteId}`
    )
  }

  deleteCallActivityCallId(callId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/call/callActivity/delete/${callId}`
    )
  }
  // activity api

  activityList(leadId: any) {
    return this.http.get(
      environment.baseUrl + `crm/activity?leadId=${leadId}`
    )
  }

  activityStatus(leadId: any, pageNo: any, size: any, typeType: any) {
    return this.http.put(
      environment.baseUrl + `crm/activity/status/${leadId}?pageNo=${pageNo}&size=${size}&typeType=${typeType}`, {}
    )
  }

  activityStatusWithType(leadId: any, pageNo: any, size: any, typeType: any, type: any) {
    return this.http.put(
      environment.baseUrl + `crm/activity/status/${leadId}?pageNo=${pageNo}&size=${size}&typeType=${typeType}&type=${type}`, {}
    )
  }
  leadActivityStatus(leadId: any, typeType: any) {
    return this.http.get(
      environment.baseUrl + `crm/activity/list?leadId=${leadId}&type=${typeType}`,
    )
  }

  // CRM Labels master + assignment
  createLabel(body: { businessId: string; name: string; color: string }) {
    return this.http.post(environment.baseUrl + `crm/master/labels`, body);
  }

  listLabels(businessId: string, includeInactive: boolean = false) {
    const inactiveParam = includeInactive ? '&includeInactive=true' : '';
    return this.http.get(
      environment.baseUrl + `crm/master/labels?businessId=${businessId}${inactiveParam}`
    );
  }

  updateLabel(labelId: string, body: { businessId: string; name: string; color: string }) {
    return this.http.put(environment.baseUrl + `crm/master/labels/${labelId}`, body);
  }

  archiveLabel(labelId: string, businessId: string) {
    return this.http.patch(
      environment.baseUrl + `crm/master/labels/${labelId}/archive?businessId=${businessId}`,
      {}
    );
  }

  assignLabels(body: {
    businessId: string;
    targetType: 'LEAD' | 'TASK' | 'CALL' | 'MEETING';
    targetId: string;
    labelIds: string[];
  }) {
    return this.http.put(environment.baseUrl + `crm/labels/assignment`, body);
  }

  //meetings module
  createMeeting(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/meeting/create`, data
    )
  }

  listMeeting(businessId: any, pageNo: any, size: any, meetingStatus: any) {
    return this.http.get(
      environment.baseUrl + `crm/meeting?businessId=${businessId}&pageNo=${pageNo}&size=${size}&meetingStatus=${meetingStatus}`
    )
  }

  listMeetingByLeadId(leadId: any, pageNo: any, size: any) {
    return this.http.get(
      environment.baseUrl + `crm/meeting/withLead/${leadId}?page=${pageNo}&size=${size}`
    )
  }

  addParticipantsByMeetId(meetId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `crm/meeting/participants/${meetId}`, data
    )
  }

  searchMeeting(businessId: any, pageNo: any, size: any, meetingStatus: any, text: any) {
    return this.http.get(
      environment.baseUrl + `crm/meeting?businessId=${businessId}&pageNo=${pageNo}&size=${size}&meetingStatus=${meetingStatus}&text=${text}`
    )
  }

  getMeetingDetails(meetingId: any) {
    return this.http.get(
      environment.baseUrl + `crm/meeting/${meetingId}`
    )
  }
  editMeeting(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/meeting/update`, data
    )
  }

  getGoogleOAuthIntegrationStatus(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/google-oauth/${businessId}/integration-status`
    )
  }

  getGoogleOAuthAuthUrl() {
    return this.http.get(
      environment.baseUrl + `crm/google-oauth/auth-url`
    )
  }

  exchangeGoogleOAuthCode(data: { business: { id: any; name: any }; code: string }) {
    return this.http.post(
      environment.baseUrl + `crm/google-oauth/exchange-code`, data
    )
  }

  updateGoogleMeetRecordingSettings(businessId: any, data: { automaticRecordingEnabled: boolean }) {
    return this.http.put(
      environment.baseUrl + `crm/google-oauth/${businessId}/meeting-recording-settings`, data
    )
  }

  syncGoogleCalendarMeeting(meetingId: any) {
    return this.http.post(
      environment.baseUrl + `crm/meeting/${meetingId}/google-calendar/sync`, {}
    )
  }

  syncMeetingRecordings(meetingId: any) {
    return this.http.post(
      environment.baseUrl + `crm/meeting/${meetingId}/recordings/sync`, {}
    )
  }

  createNotesByMeetingId(meetId: any, data: any) {
    return this.http.post(
      environment.baseUrl + `crm/meeting/notes/create/${meetId}`, data
    )
  }
  editNotesByMeetingId(meetId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `crm/meeting/notes/update/${meetId}`, data
    )
  }

  editAttachmentByMeetingId(meetId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `crm/meeting/attachments/update/${meetId}`, data
    )
  }

  getNotesByMeetingId(meetId: any) {
    return this.http.get(
      environment.baseUrl + `crm/meeting/taskDoc/${meetId}`
    )
  }


  createAttachmentsByMeetingId(meetId: any, data: any) {
    return this.http.post(
      environment.baseUrl + `crm/meeting/attachment/create/${meetId}`, data
    )
  }

  deleteAttachmentsByMeetingId(meetId: any, attachmentId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/meeting/attachment/delete/${meetId}?attachmentId=${attachmentId}`
    )
  }

  deleteMeeting(meetingId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/meeting/delete/${meetingId}`
    )
  }

  deleteMeetingByCallId(meetId: any, notesId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/meeting/notes/delete/${meetId}?notesId=${notesId}`
    )
  }

  meetingFilter(businessId: any, meetingStatus: any, pageNo: any, size: any, startDate: any, endDate: any, staffId: any, type?: any) {
    // Base URL
    let url = `${environment.baseUrl}crm/meeting/filter/${businessId}`;

    // Initialize query parameters array
    const queryParams: string[] = [];

    // Add meetingStatus if it exists
    if (meetingStatus != null) {
      queryParams.push(`meetingStatus=${meetingStatus}`);
    }

    if (type != null) {
      queryParams.push(`type=${type}`);
    }

    if (staffId != null) {
      queryParams.push(`staffId=${staffId}`);
    }

    // Always add pagination params
    queryParams.push(`pageNo=${pageNo}`);
    queryParams.push(`size=${size}`);

    // Add startDate & endDate only if both are provided
    if (startDate != null && endDate != null) {
      queryParams.push(`startDate=${startDate}`);
      queryParams.push(`endDate=${endDate}`);
    }

    // Construct the final URL
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    // Make the HTTP PUT request
    return this.http.put(url, {});

  }

  meetingListingFilter(
    businessId: any,
    meetingStatus?: any,
    pageNo?: any,
    size?: any,
    startDate?: any,
    endDate?: any,
    pipelineId?: any
    , type?: any,
    staffId?: any,
    searchText?: any,
    activityTypeCode?: any,
    storeId?: any
  ) {
    // Base URL
    let url = `${environment.baseUrl}crm/meeting/filter/${businessId}`;
    const queryParams: string[] = [];

    if (storeId) {
      queryParams.push(`storeId=${storeId}`);
    }

    // ✅ Add filters only if defined

    if (searchText) {
      queryParams.push(`searchText=${searchText.trim()}`);
    }

    if (meetingStatus) {
      queryParams.push(`meetingStatus=${meetingStatus}`);
    }

    if (activityTypeCode) {
      queryParams.push(`activityTypeCode=${activityTypeCode}`);
    }

    if (type) {
      queryParams.push(`type=${type}`);
    }

    if (staffId) {
      queryParams.push(`staffId=${staffId}`)
    }

    if (pageNo != null) {
      queryParams.push(`pageNo=${pageNo}`);
    }

    if (size != null) {
      queryParams.push(`size=${size}`);
    }

    if (startDate && endDate) {
      queryParams.push(`startDate=${startDate}`);
      queryParams.push(`endDate=${endDate}`);
    }

    if (pipelineId && pipelineId !== "all") {
      queryParams.push(`pipelineId=${pipelineId}`);
    }

    // ✅ Append query parameters (if any)
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    // ✅ Make PUT request with an empty or optional body
    return this.http.put(url, {});
  }


  meetingLeadFilter(leadId: any, meetingStatus: any, pageNo: any, size: any) {
    return this.http.put(
      environment.baseUrl + `crm/meeting/filter/lead/${leadId}?meetingStatus=${meetingStatus}&pageNo=${pageNo}&size=${size}`, {}
    )

  }



  // emails module
  listEmails(leadId: any) {
    return this.http.get(
      environment.baseUrl + `crm/mail?leadId=${leadId}`,
    )
  }
  createEmail(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/mail/create`, data
    )
  }
  editEmail(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/mail/update`, data
    )
  }
  viewEmailDetails(mailId: any) {
    return this.http.get(
      environment.baseUrl + `crm/mail/get/${mailId}`
    )
  }
  deleteEmail(id: any) {
    return this.http.delete(
      environment.baseUrl + `crm/mail/delete/${id}`
    )
  }

  // tasks module

  listTasks(businessId: any, pageNo: any, size: any, taskStatus: any) {
    if (taskStatus !== 'NEW') {
      return this.http.get(
        environment.baseUrl + `crm/task?businessId=${businessId}&pageNo=${pageNo}&size=${size}&taskStatus=${taskStatus}`
      )
    } else {
      return this.http.get(
        environment.baseUrl + `crm/task?businessId=${businessId}&pageNo=${pageNo}&size=${size}`
      )
    }

  }
  createTask(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/task/create`, data
    )
  }
  editTask(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/task/update`, data
    )
  }
  getTaskDetails(taskId: any) {
    return this.http.get(
      environment.baseUrl + `crm/task/getById/${taskId}`
    )
  }

  getTaskDocsByTaskId(taskId: any) {
    return this.http.get(
      environment.baseUrl + `crm/task/taskDoc/${taskId}`
    )
  }
  createNotesByTaskId(taskId: any, data: any) {
    return this.http.post(
      environment.baseUrl + `crm/task/notes/create/${taskId}`, data
    )
  }
  editNotesByTaskId(taskId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `crm/task/notes/update/${taskId}`, data
    )
  }
  createAttachmentsByTaskId(taskId: any, data: any) {
    return this.http.post(
      environment.baseUrl + `crm/task/attachment/create/${taskId}`, data
    )
  }
  editAttachmentsByTaskId(taskId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `crm/task/attachments/update/${taskId}`, data
    )
  }

  searchTasks(businessId: any, pageNo: any, size: any, taskStatus: any, text: any) {
    return this.http.get(
      environment.baseUrl + `crm/task?businessId=${businessId}&pageNo=${pageNo}&size=${size}&taskStatus=${taskStatus}&text=${text}`
    )
  }

  deleteTask(taskId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/task/delete/${taskId}`
    )
  }

  changeTaskStatus(taskId: any, taskStatus: any) {
    return this.http.put(
      environment.baseUrl + `crm/task/change/status?taskId=${taskId}&taskStatus=${taskStatus}`, {}
    )
  }
  getTasksByLeadId(leadId: any) {
    return this.http.get(
      environment.baseUrl + `crm/task/getByLeadId/${leadId}`
    )
  }

  deleteAttachmentByTastId(taskId: any, attachmentId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/task/attachment/delete/${taskId}?attachmentId=${attachmentId}`
    )
  }

  taskLeadOpenClose(page: any, size: any, type: any, leadId: any, queryType: any) {
    return this.http.get(
      environment.baseUrl + `crm/task/openclose?page=${page}&size=${size}&type=${type}&uuId=${leadId}&queryType=${queryType}`
    )
  }

  taskBusinessOpenClose(page: any, size: any, type: any) {

  }



  taskFilter(page: any, size: any, data: any) {
    let url = '';
    if (data.staffId) {
      url = url + `&staffId=${data.staffId}`;
    }
    return this.http.put(
      environment.baseUrl + `crm/task/filter?page=${page}&size=${size}${url}`, data
    )
  }

  // update lead status
  updateLeadStatus(leadId: any, status: any) {
    return this.http.put(
      environment.baseUrl + `crm/lead/v2/convert?leadId=${leadId}&leadType=${status}`, {}
    )
  }
  // leads filter

  openFilterLead(data: any, startDate?: string, endDate?: string) {
    const queryParams: string[] = [];

    if (startDate) {
      queryParams.push(`startDate=${encodeURIComponent(startDate)}`);
    }

    if (endDate) {
      const formattedEndDate = moment(endDate, 'DD-MM-YYYY')
        .add(1, 'days')
        .format('DD-MM-YYYY');

      queryParams.push(`endDate=${encodeURIComponent(formattedEndDate)}`);
    }

    const queryString = queryParams.length
      ? `?${queryParams.join('&')}`
      : '';

    return this.http.put(
      `${environment.baseUrl}crm/leads/filter${queryString}`,
      data
    );
  }




  //activity filter
  activityFilter(leadId: any, type: any) {
    return this.http.get(
      environment.baseUrl + `crm/activity/list?leadId=${leadId}&type=${type}`
    )
  }

  // excel for lead listing
  genrateLeadExcel(data: any, businessId: any) {
    return this.http.post(
      environment.baseUrl + `crm/leads/uploadExcel?businessId=${businessId}`, data
    )
  }

  // sub industry
  getSubIndustries(page: number, size: number) {
    return this.http.get(
      environment.serverIp + `master/business/industry/sub?size=${size}&page=${page}`
    )
  }

  getDashboardData(id: string, startDate: any, endDate: any, leadXAxisType: any, pipelineId: any) {
    // return this.http.get(
    //   environment.baseUrl + `crm/dashboard?businessId=${id}&startDate=${startDate}&endDate=${endDate}&leadXAxisType=${leadXAxisType}`
    // )
    let url = '';
    if (leadXAxisType != 'ALL') {
      url = url + `&leadXAxisType=${leadXAxisType}`;
    }
    if (pipelineId != 'ALL') {
      url = url + `&pipelineId=${pipelineId}`;
    }

    if (startDate && endDate) {
      return this.http.get(
        environment.baseUrl + `crm/dashboard?businessId=${id}&startDate=${startDate}&endDate=${endDate}${url}`
      )
    } else {
      return this.http.get(
        environment.baseUrl + `crm/dashboard?businessId=${id}${url}`
      )
    }
  }

  getDashboardV2Analytics(businessId: string, opts: { from?: string; to?: string; pipelineId?: string; staffId?: string; heatmapDays?: number; followUpLimit?: number } = {}) {
    let params = new HttpParams().set('businessId', businessId).set('granularity', 'WEEKLY');
    if (opts.from && opts.to) {
      params = params.set('from', opts.from).set('to', opts.to);
    }
    if (opts.pipelineId) {
      params = params.set('pipelineId', opts.pipelineId);
    }
    if (opts.staffId) {
      params = params.set('staffId', opts.staffId);
    }
    if (opts.heatmapDays) {
      params = params.set('heatmapDays', opts.heatmapDays);
    }
    if (opts.followUpLimit) {
      params = params.set('followUpLimit', opts.followUpLimit);
    }
    return this.http.get(
      environment.baseUrl + `crm/dashboard/v2/analytics`,
      { params }
    )
  }


  //Fields Module

  createfields(payload, formName: string) {
    return this.http.post(
      environment.baseUrl + `crm/fields?fieldCategory=${formName}`, payload
    )
  }

  updatefields(payload, formName: string) {
    return this.http.put(
      environment.baseUrl + `crm/fields?fieldCategory=${formName}`, payload
    )
  }



  getFieldsApi(businessId: any, pageNo: any, size: any, status: any, formName: any) {
    let url = ""
    if (status != null)
      url = url + `&status=${status}`
    return this.http.get(
      environment.baseUrl + `crm/fields?businessId=${businessId}&size=${size}&pageNo=${pageNo}&fieldCategory=${formName}${url}`
    )
  }

  getfieldgroupsapi(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/fields/fieldgroup?businessId=${businessId}`
    )
  }

  searchfieldgroup(payload: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/fieldgroup/filter`, payload
    )
  }

  getFieldsShowInForm(businessId: any, formName: any) {
    return this.http.get(
      environment.baseUrl + `crm/fields?businessId=${businessId}&status=true&showInForm=ENQUIRY&isPagination=false&fieldCategory=${formName}`
    )
  }

  changeHideInBulkUploadFieldStatus(fieldId: any, hideInBulkUpload: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/bulk-upload-visibility/toggle?fieldId=${fieldId}&value=${hideInBulkUpload}`, null
    )
  }

  getAllCustomFields(businessId: any, searchText: any) {
    return this.http.get(
      environment.baseUrl + `crm/fields?businessId=${businessId}&status=true&searchText=${searchText}&isPagination=false`
    )
  }

  getAllFields(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/fields?businessId=${businessId}&status=true&isPagination=false&fieldCategory=ENQUIRY`
    )
  }

  getFilterableFields(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/fields?businessId=${businessId}&fieldCategory=ENQUIRY&isFilterable=true&status=true&isPagination=false`
    )
  }

  changeFieldRequiredStatus(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/toggle`, data
    )
  }

  changeShowInEnquiryFieldStatus(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/toggle`, data
    )
  }

  viewregistrationsidepanel(id: any) {
    return this.http.get(
      environment.baseUrl + `crm/registration/${id}?examData=true`
    )
  }

  changeShowInRegistrationFieldStatus(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/toggle`, data
    )
  }

  changeShowInAdmissionFieldStatus(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/toggle`, data
    )
  }

  changeFieldStatus(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/toggle`, data
    )
  }

  searchFields(pageNo: any, size: any, searchText: any, fieldCategory: any, businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/fields?businessId=${businessId}&pageNo=${pageNo}&size=${size}&searchText=${searchText}&fieldCategory=${fieldCategory}`
    )
  }

  deleteField(fieldId: any, fieldCategory: any) {
    return this.http.delete(
      environment.baseUrl + `crm/fields?id=${fieldId}&fieldCategory=${fieldCategory}`, {}
    )
  }

  getFieldGroupApi(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/fields/fieldgroup?businessId=${businessId}`
    )
  }

  getFieldType() {
    return this.http.get(
      environment.baseUrl + `crm/fields/fieldTypes`
    )
  }

  putFieldGroupApi(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/fieldgroup/filter`, data
    )
  }

  getfieldsFieldGroupApi(fieldGroupId: any) {
    return this.http.get(
      environment.baseUrl + `crm/fields/fieldGroupId?fieldGroupId=${fieldGroupId}`
    )
  }


  createFieldGroup(payload: any) {
    return this.http.post(
      environment.baseUrl + `crm/fields/fieldgroup`, payload
    )
  }
  updateFieldGroup(payload: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/fieldgroup`, payload
    )
  }

  changeFieldGroupStatus(status: any, id: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/fieldGroup/toggle?status=${status}&id=${id}`, {}
    )
  }

  deleteFieldGroup(fieldGroupId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/fields/fieldgroup?id=${fieldGroupId}`
    )
  }


  deleteFielParentGroup(fieldGroupId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/fields/fieldParentGroup?id=${fieldGroupId}`
    )
  }

  getFieldParentGroups(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/fieldParentGroup/filter`, data
    )
  }

  createFieldParentGroup(payload: any) {
    return this.http.post(
      environment.baseUrl + `crm/fields/fieldParentGroup`, payload
    )
  }

  changeFieldParentGroupStatus(status: any, fieldGroupId: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/fieldParentGroup/toggle?status=${status}&id=${fieldGroupId}`, {}
    )
  }


  getDataSourceTypesApi() {
    return this.http.get(
      environment.baseUrl + `crm/fields/dataSourceTypes`
    )
  }





  //Templates
  getTemplates(businessId: any, pageNo: any, size: any, formCategory: any) {
    return this.http.get(
      environment.baseUrl + `crm/templates?businessId=${businessId}&size=${size}&pageNo=${pageNo}&formCategory=${formCategory}`
    )
  }

  changeTemplateStatus(status: any, templateId: any) {
    return this.http.put(
      environment.baseUrl + `crm/templates/toggle?status=${status}&id=${templateId}`, {}
    )
  }
  deleteTemplate(templateId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/templates?id=${templateId}`, {}
    )
  }

  searchTemplates(pageNo: any, size: any, searchText: any, formCategory: any) {
    return this.http.get(
      environment.baseUrl + `crm/templates?pageNo=${pageNo}&size=${size}&searchText=${searchText}&formCategory=${formCategory}`
    )
  }
  createTemplate(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/templates`, data
    )
  }
  updateTemplate(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/templates`, data
    )
  }

  getSelectedListFields(bId: any, showInErp: any, formName: any) {
    return this.http.get(
      // environment.baseUrl+`crm/fields?showInErp=${showInErp}&isPagination=false`
      // environment.baseUrl+`crm/fields?businessId=${bId}&showInErp=${showInErp}&isPagination=false`
      environment.baseUrl + `crm/fields?businessId=${bId}&status=true&showInErp=${showInErp}&isPagination=false&fieldCategory=${formName}`
    )
  }

  updateenquiryformfields(fieldId: any, formName: any, isSelected: boolean) {
    return this.http.put(
      environment.baseUrl + `crm/fields/update-selected?fieldId=${fieldId}&fieldCategory=${formName}&isSelected=${isSelected}`, ''
    )
  }

  getAllFieldsByBusinessId(bId: any) {
    return this.http.get(
      environment.baseUrl + `crm/fields?businessId=${bId}&showInErp=ENQUIRY&isPagination=false`
    )
  }

  getAllGrades() {
    return this.http.get(
      environment.baseUrl + `crm/master/getAllGradeMasterDetails`
    )
  }

  createacademicyears(payload: any) {
    return this.http.post(
      environment.baseUrl + `crm/master/saveOrUpdateAcademicYearMaster`, payload
    )
  }

  getAllAcademicYears() {
    return this.http.get(
      environment.baseUrl + `crm/master/getAllAcademicYearMasterDetails`
    )
  }

  activeInactiveFieldsForList(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/update-selected?fieldId=${data.fieldId}&fieldCategory=${data.fieldCategory}&isSelected=${data.isSelected}`, data
    )
  }

  reorderFields(payload: { businessId: string; fieldIds: string[] }) {
    return this.http.put(
      environment.baseUrl + `crm/fields/reorder`,
      payload
    )
  }

  reorderFieldGroups(payload: { businessId: string; fieldGroupIds: string[] }) {
    return this.http.put(
      environment.baseUrl + `crm/fields/fieldgroup/reorder`,
      payload
    )
  }

  getWebsiteTemplate(templateId: string) {
    return this.http.get(environment.baseUrl + `business/v3/website/${templateId}/pages/list`);
  }

  saveTemplatePage(data: any) {
    return this.http.post(
      environment.baseUrl + `business/v3/create/website`, data
    )
  }

  updateItemInWebForm(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/toggle`, data
    )
  }

  updateIsRequiredInWebFormApi(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/fields/toggle?id=${data.fieldId}&isRequired=${data.status}`, data
    )
  }

  contctUsForm(data: any) {
    return this.http.post(
      environment.baseUrl + `business/contact`, data
    )
  }

  getActiveTemplate(bId: any, formCategory: any) {
    return this.http.get(
      environment.baseUrl + `crm/templates?businessId=${bId}&status=true&formCategory=${formCategory}`
    )
  }

  sendRegistrationLink(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/leads/email?leadId=${data.leadId}&templateId=${data.templateId}`, data
    )
  }

  createSubscriptionType(payload) {
    return this.http.post(
      environment.baseUrl + `crm/subscription/type`, payload
    )
  }

  deleteSubscriptionType(id: any) {
    return this.http.delete
      (environment.baseUrl + `crm/subscription/type?id=${id}`)
  }

  getAllSubscriptionType(businessId: any, pageNo: any, size: any, searchText: any, isDeleted: any) {
    let url = ""
    if (searchText.length > 2)
      url = url + `&searchText=${searchText}`
    if (!isDeleted)
      url = url + `&isDeleted=${isDeleted}`
    return this.http.get(
      environment.baseUrl + `crm/subscription/type?businessId=${businessId}&pageNo=${pageNo}&size=${size}${url}`
    )
  }

  createSubscription(payload: any) {
    return this.http.post(
      environment.baseUrl + `crm/subscription/plan`, payload
    )
  }

  getAllSubscription(businessId, pageNo, pageSize, isDeleted, searchText) {
    let url = ""
    if (searchText.length > 2)
      url = url + `&searchText=${searchText}`
    return this.http.get(
      environment.baseUrl + `crm/subscription/plan?businessId=${businessId}&pageNo=${pageNo}&size=${pageSize}${url}`
      // &isDeleted=${isDeleted}`
    )
  }

  deleteSubscription(id: any) {
    return this.http.delete(
      environment.baseUrl + `crm/subscription/plan?id=${id}`
    )
  }

  toogleSubscription(id, status) {
    return this.http.put(
      environment.baseUrl + `crm/subscription/plan?id=${id}&status=${status}`, ''
    )
  }

  toogleSubscriptionType(id, status) {
    return this.http.put(
      environment.baseUrl + `crm/subscription/type?id=${id}&status=${status}`, ''
    )
  }


  leadBulkUpload(fileData: any, businessId: any, moduleType, staffId?: any) {
    let formData = new FormData();
    formData.append('file', fileData)

    let url = '';
    if (staffId && staffId.length > 0) {
      url = `&staffId=${staffId}`;
    }

    return this.http.post(
      environment.baseUrl + `crm/leads/get/excel-headers?businessId=${businessId}&moduleType=${moduleType}${url}`, formData
    )
  }
  getLeadStatusMaster(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/master/lead-status/business?businessId=${businessId}`
    )
  }

  leadFieldMappingExcel(fileData: any, businessId: any, payload: any, moduleType, staffId: any, pipeline: any, campaignId: any) {
    let formData = new FormData();
    formData.append('file', fileData);
    // formData.append('pipeline', new Blob(
    //     [JSON.stringify(pipeline)],
    //     { type: 'application/json' }
    // ));

    let url = '';
    if (staffId) {
      url = `&staffId=${staffId}`;
    }

    if (campaignId) {
      url = url + `&campaignId=${campaignId}`;
    }

    return this.http.post(
      environment.baseUrl +
      `crm/leads/upload/dynamic-excel?businessId=${businessId}&request=${encodeURIComponent(JSON.stringify(payload))}&moduleType=${moduleType}&pipelineId=${pipeline.id}${url}`,
      formData
    );
  }

  assistantChanged = new EventEmitter<{ kind: string; recordId: string; leadId?: string }>();
  timelineEvent = new EventEmitter<any>();
  removeListContactColumn = new EventEmitter<any>();
  editContactEvent = new EventEmitter<any>(); lead//
  editnewContact = new EventEmitter<any>(); customer//
  deleteContactEvent = new EventEmitter<any>();
  addOrRemoveItemFromWebForm = new EventEmitter<any>();
  updateIsRequiredInWebForm = new EventEmitter<any>();
  sendRegistrationLinkEvent = new EventEmitter<any>();
  // customFieldPositionLead = new EventEmitter<any>();
  crmSaveOption = new EventEmitter<any>();
  gotodashboard = new EventEmitter<any>();
  createFieldInForms = new EventEmitter<any>();

  deleteBulkLeads(leadIds: string[]) {
    // const queryString = leadIds.map(id => `leadId=${id}`).join('&');
    const url = `${environment.baseUrl}crm/leads/bulkDelete`;
    return this.http.post(url, leadIds);
  }


  assignLeadsToStaff(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/leads/bulkAssign`, data
    )
  }

  assignLeadsToCampaign(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/leads/bulkCampaignChange`, data
    )
  }

  bulkStatusChange(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/leads/bulkStatusChange`, data
    )
  }

  // Bulk move leads to a new Pipeline -> Stage -> Status (+ campaign action).
  // Validates the full pipeline/stage/status hierarchy and campaign
  // compatibility server-side - do not use bulkStatusChange for this flow.
  bulkMovePipelineStatus(data: any) {
    return this.http.patch(
      environment.baseUrl + `crm/lead/v2/bulk/move-pipeline-status`, data
    )
  }

  // Stages (each with its nested status[]) for a pipeline, scoped by lead type.
  getPipelineStagesV2(businessId: any, pipelineId: any, stageType: 'LEAD' | 'PROSPECT' | 'CUSTOMER') {
    return this.http.get(
      environment.baseUrl + `crm/lead/v2/stages?businessId=${businessId}&pipelineId=${pipelineId}&stageType=${stageType}`
    )
  }

  // Active campaigns for a pipeline (v2 - supports filtering by status[]).
  getCampaignsForPipelineV2(payload: any) {
    return this.http.put(
      environment.baseUrl + `crm/tele-sales-campaign/v2`, payload
    )
  }

  bulkSourceChange(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/leads/bulkSourceChange`, data
    )
  }
  getEnquiryStatusList(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/master/lead-status/filter`, data
    )
  }
  getFilterLeadList(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/leads/get/lead/data`, data
    )
  }


  createLeadSegment(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/segmentation`, data
    )
  }
  getAllSegments(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/segmentation/filter`, data
    )
  }

  getLeadSegmentDashboardData(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/segmentation/${businessId}/dashboard`
    )
  }
  duplicateLeadSegment(id: any) {
    return this.http.put(
      environment.baseUrl + `crm/segmentation/${id}/duplicate`, ''
    )
  }

  deleteSegment(id: any) {
    return this.http.delete(
      environment.baseUrl + `crm/segmentation/${id}/delete`
    )
  }

  changeSegmentStatus(id: any, status: boolean) {
    return this.http.put(
      environment.baseUrl + `crm/segmentation/${id}/toggle-status?status=${status}`, ''
    )
  }

  getLeadSegmentDetails(id: any) {
    return this.http.get(
      environment.baseUrl + `crm/segmentation/${id}/details`
    )
  }
  getSegmentLeads(id: any, leadType: '' | 'LEAD' | 'PROSPECT') {
    return this.http.get(
      environment.baseUrl + `crm/segmentation/${id}/leads?leadType=${leadType}`
    )
  }

  getSegmentRecords(id: any, type: 'LEAD' | 'PROSPECT' | 'CUSTOMER', pageNo: number, size: number) {
    return this.http.get(
      environment.baseUrl + `crm/segmentation/${id}/records?type=${type}&pageNo=${pageNo}&size=${size}`
    )
  }

  createLeadScoreRule(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/lead-score`, data
    )
  }
  getAllScoreRules(businessId) {
    return this.http.get(
      environment.baseUrl + `crm/lead-score/${businessId}/rules`,
    )
  }

  getLeadScoreConfig(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/lead-score/config/${businessId}/details`
    )
  }
  addScoringConfig(data) {
    return this.http.post(
      environment.baseUrl + `crm/lead-score/config`, data
    )
  }

  deleteScoreRule(id: any) {
    return this.http.delete(
      environment.baseUrl + `crm/lead-score/${id}/delete`
    )
  }

  changeScoreRuleStatus(id: any, status: boolean) {
    return this.http.put(
      environment.baseUrl + `crm/lead-score/${id}/toggle-status?status=${status}`, ''
    )
  }

  getScoreRuleDetails(id: any) {
    return this.http.get(
      environment.baseUrl + `crm/lead-score/${id}/details`
    )
  }
  updateLeadScoreConfig(businessId, businessName) {
    return this.http.put(
      environment.baseUrl + `crm/lead-score/default-config/${businessId}?businessName =${businessName}`, ''
    )
  }


  // for email template listing 
  emailTemplateFilterListing(data: any, businessId: any) {
    return this.http.put(
      environment.baseUrl + `crm/email-template/${businessId}/filter`,
      data
    )
  }

  createEmailTemplate(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/email-template`,
      data
    )
  }

  deleteEmailTemplate(emailId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/email-template/${emailId}`
    )
  }

  duplicateEmailTemplate(emailId: any) {
    return this.http.put(
      environment.baseUrl + `crm/email-template/${emailId}/duplicate`,
      {}
    )
  }

  getEmailDetailsByEmailId(emailId: any) {
    return this.http.get(
      environment.baseUrl + `crm/email-template/${emailId}`
    )
  }

  downloadSegmentExcel(segmentId: any, type: '' | 'LEAD' | 'PROSPECT' | 'CUSTOMER') {
    return this.http.get(
      environment.baseUrl + `crm/segmentation/${segmentId}/export-template?type=${type}`, { responseType: 'blob' }
    )
  }


  downloadLeadsExcel(filters: any): any {
    let params = new HttpParams();

    const formatDate = (date: any) => {
      if (!date) return '';
      const d = new Date(date);
      const day = ('0' + d.getDate()).slice(-2);
      const month = ('0' + (d.getMonth() + 1)).slice(-2);
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // ✅ type
    if (filters.type) {
      params = params.set('type', filters.type);
    }

    // ✅ status (array of strings)
    if (Array.isArray(filters.status)) {
      filters.status.forEach((s: any) => {
        if (s) params = params.append('status', s);
      });
    }

    // ✅ source (array of strings)
    if (Array.isArray(filters.source)) {
      filters.source.forEach((s: any) => {
        if (s) params = params.append('source', s);
      });
    }

    // ✅ assignedStaff (array of objects → extract id, staffId, or name)
    if (Array.isArray(filters.assignedStaff)) {
      filters.assignedStaff.forEach((staff: any) => {
        const value = staff?.id || staff?.staffId || staff?.name || staff;
        if (value) params = params.append('assignedStaff', value);
      });
    }

    // ✅ pipelineId
    if (filters.pipelineId) {
      params = params.set('pipelineId', filters.pipelineId);
    }

    // ✅ searchText (FormControl or string)
    if (filters.searchText) {
      const search =
        typeof filters.searchText === 'object'
          ? filters.searchText?.value || ''
          : filters.searchText;
      if (search) params = params.set('searchText', search);
    }

    // ✅ startDate and endDate
    if (filters.startDate) {
      params = params.set('startDate', formatDate(filters.startDate));
    }

    if (filters.endDate) {
      params = params.set('endDate', formatDate(filters.endDate));
    }

    // ✅ API call
    return this.http.put(
      `${environment.baseUrl}crm/leads/${filters.businessId}/export`,
      filters, {
      responseType: 'blob'
    }
    );
  }
  getPipeLineById(pipelineId: any) {
    return this.http.get(environment.baseUrl + `crm/pipeline/${pipelineId}`)
  }
  getListPipelines(businessId: any, staffId?: any, type?: any) {
    let params = new HttpParams();

    if (staffId) {
      params = params.set('staffId', staffId);
    }

    params = params.set('active', type ? type : true);

    return this.http.get(
      `${environment.baseUrl}crm/pipeline/${businessId}/pipelines`,
      { params }
    );
  }

  filterListPipelines(
    businessId: any,
    staffId?: any,
    filters?: { status?: any; searchText?: any }
  ) {
    let params: string[] = [];

    // Optional staffId
    if (staffId) {
      params.push(`staffId=${staffId}`);
    }

    // Optional active status
    if (filters?.status === 'true' || filters?.status === 'false') {
      params.push(`active=${filters.status}`);
    }

    // Optional search text
    if (filters?.searchText && filters.searchText.trim() !== '') {
      params.push(`searchText=${encodeURIComponent(filters.searchText.trim())}`);
    }

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';

    const url = `${environment.baseUrl}crm/pipeline/${businessId}/pipelines${queryString}`;

    return this.http.get(url);
  }



  createPipelines(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/pipeline/v2`, data
    )
  }

  updatePipeline(data: any) {
    return this.http.put(
      environment.baseUrl + `crm/pipeline/v2/update`, data
    )
  }

  duplicatePipeline(pipelineId, pipelineName) {
    return this.http.post(
      environment.baseUrl + `crm/pipeline/duplicate?newPipelineName=${pipelineName}&existingPipelineId=${pipelineId}`, ''
    )
  }

  deletePipeline(pipelineId: string) {
    return this.http.delete(
      environment.baseUrl + `crm/pipeline/${pipelineId}`
    )
  }

  getAllPipelineLeads(type: string, businessId: string) {
    return this.http.get(
      `${environment.baseUrl}crm/pipeline/leads`,
      { params: { businessId, type } }
    );
  }

  getPipelineLeads(pipelineId: string, type: string, businessId: string) {
    return this.http.get(
      `${environment.baseUrl}crm/pipeline/${pipelineId}/leads`,
      { params: { businessId, type } }
    );
  }


  getPipelineTasks(pipelineId: string) {
    return this.http.get(`${environment.baseUrl}crm/pipeline/${pipelineId}/tasks`);
  }

  getPipelineMeetings(pipelineId: string) {
    return this.http.get(`${environment.baseUrl}crm/pipeline/${pipelineId}/meetings`);
  }

  getPipelineCalls(pipelineId: string) {
    return this.http.get(`${environment.baseUrl}crm/pipeline/${pipelineId}/calls`);
  }

  updatePipelineLeads(leadId: any, stageId: any) {
    return this.http.put(
      environment.baseUrl + `crm/pipeline/update/lead-stage?leadId=${leadId}&stageId=${stageId}`, ''
    )
  }

  togglePipelineStatus(pipelineId: any) {
    return this.http.put(
      environment.baseUrl + `crm/pipeline/${pipelineId}/toggle-status`,
      ''
    );
  }
  makeDefaultPipeline(pipelineId: any) {
    return this.http.put(
      environment.baseUrl + `crm/pipeline/${pipelineId}/mark-default`,
      ''
    );
  }


  createForm(form: any) {
    return this.http.post(
      environment.baseUrl + 'crm/forms',
      form
    );
  }

  updateForm(id: any, form: any) {
    return this.http.put(
      environment.baseUrl + `crm/forms/${id}`,
      form
    );
  }


  deleteForm(id: any) {
    return this.http.delete(
      environment.baseUrl + `crm/forms/${id}`
    );
  }

  toggleActive(id: any, status: boolean) {
    return this.http.put(
      environment.baseUrl + `crm/forms/${id}/toggle-active?status=${status}`,
      ''
    );
  }


  setDefaultForm(id: any) {
    return this.http.put(
      environment.baseUrl + `crm/forms/${id}/set-default`,
      ''
    );
  }


  filterForms(payload: any) {
    return this.http.put(
      environment.baseUrl + 'crm/forms/filter',
      payload
    );
  }


  getPipelinesByBusinessId() {
    return this.http.get(
      environment.baseUrl + `crm/pipeline/${localStorage.getItem('businessId')}/pipelines?active=true`
    );
  }

  getStagesByPipelineId(pipelineId: any, stageType?: any) {
    let url = environment.baseUrl +
      `crm/lead/v2/stages?businessId=${localStorage.getItem('businessId')}&pipelineId=${pipelineId}`;

    if (stageType) {
      url += `&stageType=${stageType}`;
    }

    return this.http.get(url);
  }

  getAllStageBuBusinessId(businessId: string) {
    return this.http.get(
      environment.baseUrl + `crm/lead/v2/stages?businessId=${businessId}`
    )
  }

  saveStage(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/lead/v2/stages`, data
    );
  }

  getStatusByPipelineId(pipelineId: any, type?: 'LEAD' | 'PROSPECT') {
    let url = ''
    if (pipelineId != null)
      url = url + `&pipelineId=${pipelineId}`

    return this.http.get(
      environment.baseUrl + `crm/lead/v2/status?businessId=${localStorage.getItem('businessId')}&type=${type}${url}`,
    );
  }

  getAllLeadSource() {
    let businessId = localStorage.getItem('businessId')
    return this.http.get(
      environment.baseUrl + `crm/master/lead-source/business?businessId=${businessId}`,
    );
  }

  getSourceByPipelineId(pipelineId: any) {
    return this.http.get(
      environment.baseUrl + `crm/master/lead-source/pipeline?pipelineId=${pipelineId}`,
    );
  }

  getCrmStaffByBusinessId(searchText?: string) {

    let url = ''
    if (searchText) {
      url = `&searchText=${searchText}`
    }

    return this.http.get(
      environment.baseUrl + `crm/pipeline/pipelineId?businessId=${localStorage.getItem('businessId')}${url}`
    );
  }

  updateStaffDetailsInPipeline(payload: any) {
    return this.http.put(
      environment.baseUrl + `crm/pipeline/updateStaff`, payload
    );
  }

  updateStageAndStatus(leadId: any, payload: any) {
    return this.http.patch(
      environment.baseUrl + `crm/lead/v2/update/status?leadId=${leadId}`, payload
    )
  }

  getContact(request: GetContactRequest) {
    return this.http.put<any>(environment.baseUrl + `crm/lead/v2/list`, request)
  }

  addLeadProduct(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/leads/product/master`, data
    )
  }

  addProductForLead(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/leads/product/interest`, data
    )
  }

  getAllLeadProducts(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/leads/product/master?businessId=${businessId}`
    )
  }

  getProductForLead(businessId: any, leadId: string) {
    return this.http.get(
      environment.baseUrl + `crm/leads/product/interest?businessId=${businessId}&leadId=${leadId}`
    )
  }

  getAllTimelines() {
    return this.http.get(
      environment.baseUrl + `crm/leads/timeLineTypes`
    )
  }

  deleteProductFromLeas(id: any) {
    return this.http.delete(
      environment.baseUrl + `crm/leads/product/interest?id=${id}`
    )
  }

  addSocialLinks(leadId: any, data: any) {
    return this.http.put(
      environment.baseUrl + `crm/leads/add/channels?leadId=${leadId}`, data
    )
  }

  makeCall(mobileNumber: any, leadId: any, staffId: any, businessId: any, staffName) {
    return this.http.post(
      environment.baseUrl + `crm/telecmi/click-to-call?to=${mobileNumber}&leadId=${leadId}&staffId=${staffId}&businessId=${businessId}&staffName=${staffName}`, {}
    )
  }

  playAudioFile(callerId) {
    const businessId = localStorage.getItem('businessId');
    return this.http.get(
      environment.baseUrl + `crm/telecmi/play-recording/?callId=${callerId}&businessId=${businessId}`, {
      responseType: 'blob'   // 🔥 VERY IMPORTANT
    }
    )
  }

  getUnMappedAdsLeads(businessId: string) {
    return this.http.get(
      environment.baseUrl + `crm/google-ads/forms/${businessId}`
    )
  }

  getAdsCampaignForms(businessId: string) {
    return this.http.get(
      environment.baseUrl + `crm/google-ads/forms/${businessId}/campaign`
    )
  }

  getFormFieldsToMap(formId: string) {
    return this.http.get(
      environment.baseUrl + `crm/google-ads/forms/fields/${formId}`
    )
  }

  setMappedFormFields(request: any) {
    return this.http.post(
      environment.baseUrl + `crm/google-ads/map/fields`, request
    )
  }

  updateAdsForm(request: any) {
    return this.http.put(
      environment.baseUrl + `crm/google-ads/update/form`,
      request
    )
  }

  convertAdsLeads(formId: string, pipelineId: string, campaignId: string) {

    let url = "";
    if (campaignId) {
      url = url + `&campaignId=${campaignId}`
    }
    if (pipelineId) {
      url = url + `&pipelineId=${pipelineId}`
    }

    return this.http.put(
      environment.baseUrl + `crm/google-ads/leads/convert/${formId}?${url}`, ''
    )
  }

  connectIVR(request: any) {
    return this.http.post(
      environment.baseUrl + `crm/telecmi/config`, request
    )
  }

  getTeleCmi(businessId: string) {
    return this.http.get(
      environment.baseUrl + `crm/telecmi/config?businessId=${businessId}`
    )
  }

  disconnectIVR(businessId: string) {
    return this.http.delete(
      environment.baseUrl + `crm/telecmi/config?businessId=${businessId}`,
      { responseType: 'text' }
    )
  }


  // get telesales dashboard get api 
  getTeleSalesDashboard(bId: any, sId: any, pipelineId: any, startDate: any, endDate: any) {

    let url = ''
    if (sId) {
      url = url + `&staffId=${sId}`;
    }
    if (pipelineId) {
      url = url + `&pipelineId=${pipelineId}`;
    }

    if (startDate && endDate) {
      return this.http.get(
        environment.baseUrl + `crm/dashboard/telesales?businessId=${bId}&startDate=${startDate}&endDate=${endDate}${url}`
      )
    } else {
      return this.http.get(
        environment.baseUrl + `crm/dashboard/telesales?businessId=${bId}${url}`
      )
    }
  }

  crmCampaignLogos: any = {
    'HIGHEST': "",
    'HIGH': "",
    'MEDIUM': "",
    'LOW': "",
    'LOWEST': ""
  }

  createCrmCampaign(payload: any) {
    return this.http.post(
      environment.baseUrl + `crm/tele-sales-campaign`, payload
    );
  }

  getAllCrmCampaigns(payload: any) {
    return this.http.put(
      environment.baseUrl + `crm/tele-sales-campaign`, payload
    )
  }

  deleteCrmCampaign(campaignId: any) {
    return this.http.delete(
      environment.baseUrl + `crm/tele-sales-campaign/${campaignId}/delete`
    )
  }

  updateVisitStatus(data: any) {

    let url = ''

    if (data.status) {
      url = url + `&meetingStatus=${data.status}`
    }

    if (data.meetingSuccessful != null) {
      url = url + `&meetingSuccessful=${data.meetingSuccessful}`
    }

    if (data.meetId) {
      url = url + `&meetId=${data.meetId}`
    }

    if(data.invoiceNo) {
      url = url + `&invoiceNo=${data.invoiceNo}`
    }

    return this.http.put(
      environment.baseUrl + `crm/meeting/update/meet/lead?${url}`, data
    )
  }
  ivrUpdateNotes(leadId: any, note: any, data: any, followUpDate: any, callDuration: any) {
    let url = '';
    if (followUpDate) {
      url = url + `&followUpDate=${followUpDate}`
    }
    data.note = note;
    return this.http.put(
      environment.baseUrl + `crm/leads/update/status/note?leadId=${leadId}&staffId=${localStorage.getItem('staffId')}&staffName=${localStorage.getItem('staffName')}&staffMail=${localStorage.getItem('staffEmail')}${url}&callDuration=${callDuration}`, data
    )
  }

  // get all coupons by bId 
  getAllCoupons(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/coupons?businessId=${businessId}`
    )
  }

  // for creating a coupon or update the coupon
  createCoupon(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/coupons`,
      data
    )
  }


  // get all coupons by bId 
  getAllEvents(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/events?businessId=${businessId}`
    )
  }

  // for creating a coupon or update the coupon
  createEvent(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/events`,
      data
    )
  }

  createCustomForm(data: any) {
    return this.http.post(
      environment.baseUrl + `crm/custom/form`, data
    )
  }

  getAllCustomForms(businessId: any) {
    return this.http.get(
      environment.baseUrl + `crm/custom/form?businessId=${businessId}`
    )
  }
  updateSourceToDefault(sourceId: string) {
    return this.http.put(
      environment.baseUrl + `crm/master/lead-source/status/default?businessId=${localStorage.getItem('businessId')}&leadSourceId=${sourceId}`, {}
    )
  }
  fetchStoreList(data: any) {
    return this.http.put(
      environment.baseUrl + `ecommerce/store/get`, data
    );
  }

  exportVisits(data: any) {
    return this.http.put(environment.baseUrl + `crm/meeting/export`, data, { responseType: 'blob' });
  }

  getLeadAnalyticsDashboard(userId, isJewelery: boolean) {
    let businessId = localStorage.getItem('businessId')

    return this.http.get(
      environment.baseUrl + `ecommerce/analytics/dashboard/${userId}?businessId=${businessId}&isJewelery=${isJewelery}`
    )
  }

  checkAppInstalledOrNot(appName) {
    let businessId = localStorage.getItem('businessId')

    return this.http.post(
      environment.baseUrl + `app/app/check/installed?businessId=${businessId}&appName=${appName}`, ''
    )
  }

  /** Whether the 'Products' CRM feature is enabled for this business. Used
   * to gate Products UI in lead detail, visit-detail, and call-dispose.
   * Reads the same `crm_features_${businessId}` localStorage flag list the
   * rest of CRM already uses for feature toggles (see mobile-details-page's
   * initFeatureFlags()) instead of hitting the network. */
  isProductAppInstalled(): boolean {
    const businessId = localStorage.getItem('businessId');
    const raw = localStorage.getItem(`crm_features_${businessId}`);
    if (!raw) return false;
    try {
      const flags = JSON.parse(raw);
      return !!flags?.find((f: any) => f.key === 'Products')?.enabled;
    } catch {
      return false;
    }
  }

  getPassbookToken(businessId: string, userId: string, userType: string) {
    return this.http.post(
      environment.baseUrl + `passbook/ext/connect/simpo/token?businessId=${businessId}&userId=${userId}&userType=${userType}`, {}
    )
  }

  getPassbookVouchers() {
    const token = localStorage.getItem('passbookToken')

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.get(
      environment.baseUrl + `passbook/voucher/list`,
      { headers }
    );
  }

  exportCallLogs(businessId: any, pipelineId: any, data: any) {
    if (pipelineId === 'all') {
      return this.http.put(
        environment.baseUrl + `crm/call/export/${businessId}`, data, { responseType: 'blob' }
      )
    }
    else {
      return this.http.put(
        environment.baseUrl + `crm/call/export/${businessId}?pipelineId=${pipelineId}`, data, { responseType: 'blob' }
      )
    }
  }
}

